<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label"
    >{{ httpService.getTransation().PrintPattern }}</span
  >
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="loading-indicator" *ngIf="pleaseWaitPdf || pleaseWaitLoad">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>
<div class="print-modal-wrapper">
  <div
    class="print-content-container"
    [ngStyle]="{ 'width' : data.printContentWidth.toString() + 'px', 'height' : data.printContentHeight.toString() + 'px' }"
  >
    <div *ngIf="!pleaseWaitLoad" id="printContent" class="print-content">
      <h5>{{ httpService.getTransation().BeadsPalette }}</h5>
      <div id="legendaContent" class="legenda-flex-container">
        <div *ngFor="let bc of beadsCount" class="legenda-grid-row">
          <div
            [class]="getBeadClasses(bc.beadPaletteTypeId, '')"
            [ngStyle]="{'background-color': '#' + bc.beadColor}"
          ></div>
          <div class="text-center">
            {{ httpService.getTransation().BeadNumber }}: <b>{{ bc.letter}}</b>
          </div>
          <div class="text-center"><b>{{ bc.beadName}}</b></div>
          <div class="text-center">
            {{ httpService.getTransation().Count }}: <b>{{ bc.count}}</b>
          </div>
        </div>
      </div>
      <div
        id="beadsGridContent"
        style="display: flex; flex-direction: column"
        *ngIf="showPatternPreview"
      >
        <div *ngIf="isChunked()" style="text-align: center; font-weight: bold">
          Pattern page: {{page}} of {{pages}} (row: {{chunkedBeadsGrid[page -
          1].startRow+1}} - {{chunkedBeadsGrid[page-1].endRow+1}}, column:
          {{chunkedBeadsGrid[page - 1].startColumn+1}} -
          {{chunkedBeadsGrid[page-1].endColumn+1}})
        </div>
        <div #beadGridContainer class="bead-grid-container">
          <div
            *ngFor="let r of chunkedBeadsGrid[page - 1].details.slice(0, visibleGridRows); index as rowIndex"
            [ngStyle]="{'margin-left': getRowLeftMargin(rowIndex) + 'px'}"
            [class]="getBeadGridRowClass()"
          >
            <div
              *ngFor="let c of r; index as colIndex"
              [class]="getBeadGridCellClass()"
              [ngStyle]="getBeadGridCellStyle(colIndex, c)"
            >
              {{ getBeadLetter(page - 1, rowIndex, colIndex) }}
            </div>
          </div>
          <!-- Preview mode blur overlay for grid -->
          <div
            *ngIf="isPreviewMode && hiddenGridRows > 0"
            class="preview-blur-overlay"
          >
            <div class="blur-content">
              <div
                *ngFor="let r of chunkedBeadsGrid[page - 1].details.slice(visibleGridRows, visibleGridRows + 3); index as rowIndex"
                [ngStyle]="{'margin-left': getRowLeftMargin(rowIndex + visibleGridRows) + 'px'}"
                [class]="getBeadGridRowClass()"
              >
                <div
                  *ngFor="let c of r; index as colIndex"
                  [class]="getBeadGridCellClass()"
                  [ngStyle]="getBeadGridCellStyle(colIndex, c)"
                >
                  {{ getBeadLetter(page - 1, rowIndex + visibleGridRows,
                  colIndex) }}
                </div>
              </div>
            </div>
            <div class="unlock-message">
              <mat-icon>more_horiz</mat-icon>
              <span>{{ hiddenGridRows }} more rows hidden</span>
            </div>
          </div>
        </div>
      </div>

      <div
        id="wordChartContent"
        class="bead-grid-list-container"
        *ngIf="showWordChart"
      >
        <table>
          <tr
            *ngFor="let bgRow of getCurrentWordChartRows(); index as rowIndex"
            class="bead-grid-list-item"
          >
            <td class="bead-grid-list-item-row-header">
              <i>{{ bgRow.rowHeader }}</i>
            </td>
            <td class="bead-grid-list-item-row-cells">
              <div fxLayout="row wrap">
                <div
                  class="bead-grid-list-item-row-cell"
                  *ngFor="let bgCell of bgRow.cells"
                >
                  <b>{{ bgCell.letter}}</b
                  ><small>({{ bgCell.count.toString() }})</small>
                </div>
              </div>
            </td>
          </tr>
          <!-- Preview mode blur overlay for word chart -->
          <tr *ngIf="isPreviewMode && hiddenWordChartRows > 0">
            <td colspan="2" class="preview-blur-section">
              <div class="blur-text-overlay">
                <mat-icon>more_horiz</mat-icon>
                <span>{{ hiddenWordChartRows }} more rows hidden</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="print-dialog-actions">
    <div *ngIf="!isChunked() || !showPatternPreview"></div>
    <div *ngIf="isChunked() && showPatternPreview" class="pagination-controls">
      <button
        mat-raised-button
        color="primary"
        class="modal-button"
        (click)="onPreviousPage()"
        style="width: 80px"
      >
        {{ httpService.getTransation().Previous }}
      </button>
      <div>{{httpService.getTransation().Page}} {{page}} of {{pages}}</div>
      <button
        mat-raised-button
        color="primary"
        class="modal-button"
        (click)="onNextPage()"
        style="width: 80px"
      >
        {{ httpService.getTransation().Next }}
      </button>
    </div>
    <div class="action-buttons">
      <mat-form-field
        appearance="outline"
        *ngIf="!isPreviewMode"
        class="include-option-dropdown"
      >
        <mat-label>Include in PDF</mat-label>
        <mat-select
          [(ngModel)]="includeOption"
          (selectionChange)="onIncludeOptionChange()"
        >
          <mat-option value="both">Both Pattern and Word Chart</mat-option>
          <mat-option value="pattern">Pattern Only</mat-option>
          <mat-option value="wordChart">Word Chart Only</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Export PDF button for subscribed users -->
      <button
        *ngIf="!isPreviewMode"
        mat-raised-button
        color="warn"
        class="modal-button"
        [disabled]="pleaseWaitPdf"
        (click)="onExportPDF()"
      >
        {{ httpService.getTransation().ExportPDF }}
      </button>
      <!-- Subscribe CTA for free users in preview mode -->
      <app-upgrade-preview-cta
        *ngIf="isPreviewMode"
        [title]="httpService.getTransation().ReaderPreviewTitle"
        [description]="httpService.getTransation().PrintProfessionalGuides"
        [hiddenRowsCount]="previewHiddenRowsCount"
        [buttonLabel]="httpService.getTransation().ReaderUpgradeCta"
        (ctaClick)="onSubscribeClick()"
      ></app-upgrade-preview-cta>
    </div>
  </div>
</div>
